module.exports = __webpack_public_path__ + "img/expressFreightShipment.5e0d12d1.svg";